import connectAutocomplete from './connectAutocomplete'
import withValueState from './withValueState'

import AddressAutocomplete from '../../components/Form/AddressAutocomplete'

export default withValueState(connectAutocomplete('address', AddressAutocomplete))



// WEBPACK FOOTER //
// ./deps/internal-components/src/containers/Form/AddressAutocomplete.js